// extracted by mini-css-extract-plugin
export default {"Container":"Latest_Container__xEq9V","Results":"Latest_Results__cxuBw"};